import { HeaderBar } from '@fortem-monorepo/react-spa'

import { LayoutOutlet } from '@/components/LayoutOutlet'
import { NavigationTabs, NavigationTabsList } from '@/components/NavigationTabs'
import { INSTRUMENTS_LINKS } from '@/constants/links'

export interface InstrumentsLayoutProps {}

export const InstrumentsLayout: React.FC<InstrumentsLayoutProps> = ({}) => {
  return (
    <>
      <HeaderBar>
        <NavigationTabs>
          <NavigationTabsList links={INSTRUMENTS_LINKS} />
        </NavigationTabs>
      </HeaderBar>
      <LayoutOutlet />
    </>
  )
}
